import { render, staticRenderFns } from "./PainelLoteLegado.vue?vue&type=template&id=2b82d35e&scoped=true"
import script from "./PainelLoteLegado.vue?vue&type=script&lang=js"
export * from "./PainelLoteLegado.vue?vue&type=script&lang=js"
import style0 from "./PainelLoteLegado.vue?vue&type=style&index=0&id=2b82d35e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b82d35e",
  null
  
)

export default component.exports